import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { propChildren, propStr } from '../../../../helpers/custom-prop-types';
import SlideSearchTitleIcon from '../../../Icon/Svg/SlideSearchTitleIcon';
import Hover from '../../../Ui/System/Hover';
const SlideSearchHeaderLogo = (props) => {
    const { className, logoClassName, to } = props;
    return (_jsx("div", Object.assign({ className: clsx('slide_search_header_logo', className) }, { children: _jsx(Hover, { children: _jsx(Link, Object.assign({ to: to }, { children: _jsx(SlideSearchTitleIcon, { className: clsx('logo_svg color', logoClassName) }) })) }) })));
};
SlideSearchHeaderLogo.propTypes = {
    className: propStr(),
    logoClassName: propChildren(),
    to: propStr(),
};
SlideSearchHeaderLogo.defaultProps = {
    className: '',
    logoClassName: '',
    to: '/proffit_search',
};
export default SlideSearchHeaderLogo;
